"use client"

// src/config.ts
var config = {
  breakpoint: { direction: "down", identifier: "@media screen" },
  initialColorMode: "light",
  initialThemeScheme: "base",
  var: { prefix: "ui" }
};

export {
  config
};
//# sourceMappingURL=chunk-CRA67K35.mjs.map